import React from 'react';

const FailureImage = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M18.5 99V23a8 8 0 0 1 8-8h52a8 8 0 0 1 8 8v76a8 8 0 0 1-8 8h-52a8 8 0 0 1-8-8z' fill='var(--theme-light,#e2cff7)' />
      <path
        d='M30.5 37h44m-44 16H63M30.5 69h29m-29 16h39m-51 14V23a8 8 0 0 1 8-8h52a8 8 0 0 1 8 8v76a8 8 0 0 1-8 8h-52a8 8 0 0 1-8-8z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='4.4'
        strokeLinecap='round'
      />
      <circle cx='80.5' cy='69' r='23.8' fill='var(--theme-light,#e2cff7)' stroke='var(--theme-primary, #810ea9)' strokeWidth='4.4' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M71.984 60.516a2.77 2.77 0 0 0 0 3.916l4.57 4.57-4.569 4.567a2.77 2.77 0 0 0 3.917 3.916l4.568-4.567 4.569 4.568a2.77 2.77 0 1 0 3.916-3.916l-4.569-4.569 4.57-4.57a2.77 2.77 0 0 0-3.916-3.916l-4.57 4.57-4.57-4.57a2.77 2.77 0 0 0-3.916 0z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );
};

export default FailureImage;
